<template>
  <vs-table hover-flat v-if="soundFiles && soundFiles.length" :data="soundFiles">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('file_name')"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count"></vs-td>
        <vs-td v-text="tr.file"></vs-td>
        <vs-td>
          <div class="flex justify-center">
            <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="$emit('customClickDelete', tr.id)"></vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>

export default {
  name: 'Shared.SoundFiles.List',
  props: {
    soundFiles: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style scoped>

</style>
